<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main" style="padding-bottom:10px; padding-left:60px; padding-top:60px;
        padding-right: 60px">
          <div class="title">
            科研服务
          </div>
          <div class="contentLeft">
            <ul class="leftNavigation">
<!--              <li><a href="service0?id=&cat=pt" style="font-weight:bold"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>分析测试（公共仪器平台）</a></li>-->
              <li><a href="javascript:void(0)" onclick="var arr1 = document.getElementsByName('jshz_');for(var i = 0;i<arr1.length;i++){arr1[i].style.display = 'none';} var arr12 = document.getElementsByName('fxcs_');for(var i = 0;i<arr12.length;i++){arr12[i].style.display = 'block';}" style="font-weight:bold"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>分析测试（公共仪器平台）</a></li>
              <li v-for="item in kyfwList" :key="item" v-if="item.type==2" name="fxcs_" :style="'display:' + item.display">
                <a :href="item.url + '&cat=pt'" ><span style="margin-left: 15px;">{{ item.title }}</span></a>
              </li>
              <li name="fxcs_" id="fxcs_o1"><a target="_blank" href="http://iac.sjtu.edu.cn" ><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>&nbsp;&nbsp;公共仪器平台仪器预约</a></li>
              <li name="fxcs_" id="fxcs_o2"><a target="_blank" href="https://tmcore.sjtu.edu.cn" ><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>&nbsp;&nbsp;用户共享资源预约</a></li>

              <!--              <li><a href="service0?id=&cat=zx" style="font-weight:bold"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>技术合作</a></li>-->
              <li><a href="javascript:void(0)" onclick="var arr = document.getElementsByName('jshz_');for(var i = 0;i<arr.length;i++){arr[i].style.display = 'block';} var arr2 = document.getElementsByName('fxcs_');for(var i = 0;i<arr2.length;i++){arr2[i].style.display = 'none';}" style="font-weight:bold"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>技术合作</a></li>
              <li v-for="item in kyfwList" :key="item"  v-if="item.type==1" name="jshz_" :style="'display:' + item.display">
                <a :href="item.url + '&cat=zx'" ><span style="margin-left: 15px;">{{ item.title }}</span></a>
              </li>
              <li><a href="service11" target="_blank" style="font-weight:bold"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>用户实验室</a></li>
              <li><a href="service12" target="_blank" style="font-weight:bold"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>会议服务</a></li>
            </ul>
          </div>
          <div class="contentRight" style="">
            <p style="text-align: left; margin-top: -70px;"><span style="font-size: 22px; border-bottom: solid 3px #0c5cc8;">{{ title }}</span></p>
            <p >&nbsp;</p>
            <div id="headerDesc" class="right">
              <div @mouseover="showHover=true" @mouseout="showHover=false" class="btn">
                <span style="color: #0c5cc8">负责人介绍 ▼&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <div class="hover_container" v-if="showHover">
                  <div style="float: left;width: 160px; height: 298px; background-color: #e7e8ea">
                    <img :src="headPicture" style="padding: 20px;" alt="">
                  </div>
                  <div style="overflow: hidden; margin-top: 10px; text-align: left; line-height:30px; padding-left: 10px; ">
                    <span style="font-weight: bold">负责人：{{ headName }}</span><br/>
                    <span style="">{{ headDescription }}</span>
                  </div>
  <!--                <div style="margin-top: 10px; text-align: left;line-height:30px;margin-left: 170px; ">-->
  <!--                  {{ headDescription }}-->
  <!--                </div>-->
                </div>
              </div>
            </div>
            <p >&nbsp;</p><p >&nbsp;</p>
            <div class="b-richtext" style="margin-top:1px;">
              <p v-html="richText"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <!--
    <v-footer></v-footer>
    <v-copy></v-copy>
    -->
  </div>
</template>
<script>
  /* eslint-disable */
  import Header from "@/components/header/";
  import Nav from "@/components/nav/";
  import Copy from "@/components/copy/"
  import Breadcrumb from "@/components/breadcrumb/"
  import Footer from "@/components/footer/"
  import Contact from "@/components/contact/";
  import $ from "jquery";
  export default {
    methods: {
      hide_jshz() {
        var arr = document.getElementsByName("jshz_");
        for(var i = 0;i<arr.length;i++){
          arr[i].style.display = "none";
        }
      }
    },

    data () {
      return {
        richText: '',
        showHover: false,
        kyfwList: [],
        title: '',
        headName: '',
        headPicture: '',
        headDescription: '',
        id: ''
      };
    },
    mounted () {
      var self = this;
      var id = this.$route.query.id;
      var category = this.$route.query.cat;
      if(category == 'zx'){
        console.log("中心介绍 内容页面。");
        self.richText = "<div style='font-size: 20px; height: 550px; text-align: center'>中心介绍 内容页面。</div>" ;
        if (id == '')
          $("#headerDesc").css('display', 'none');
        else
          $("#headerDesc").css('display', '');
      }else if(category == 'pt'){
        console.log("平台介绍 内容页面。");
        self.richText = "<div style='font-size: 20px; height: 550px; text-align: center;display: '>平台介绍 内容页面。</div>" ;
        if (id == '')
          $("#headerDesc").css('display', 'none');
        else
          $("#headerDesc").css('display', '');
      }

      var baseUrl =  Header.IP_URL + '/research_service/detail?research_serviceId='+id;

      $.ajax({
        url: baseUrl,
        type: 'get',
        // data: {},
        dataType: 'json'
      }).then(function (res) {
          //把从json获取的数据赋值给数组
          console.log(res.data.title);
          self.title = res.data.title;
          self.headPicture = Header.IP_URL + "/ueditor/images/" + res.data.picture;
          self.headName = res.data.headName;
          self.headDescription = res.data.headDescription;
          console.log(self.headPicture);

          var content = res.data.content;
          content = content.replace(/<p>/g, "<p style=\"text-indent:0em; margin-bottom : 20px; font-size: 16px; line-height:32px;margin: auto;\">");
          content = content.replace(/<p style=\"text-align: center;\">/g, '<p style="text-align: center;margin-bottom : 20px; font-size: 16px;">');

          content = content.replace(/width:1240px;line-height:32px;margin: auto;"><img/g, 'text-align:center;"><img');

          content = content.replace(/\/ueditor\/images/g, Header.IP_URL + "/ueditor/images");
          content = content.replace(/\/ueditor\/file/g, Header.IP_URL + "/ueditor/file");
          content = content.replace(/\/ueditor\/video/g, Header.IP_URL + "/ueditor/video");

          //设置图片的宽度
          // 先去除原来的 设置

          content = content.replace(/height="(\d*)"/g, '');
          //console.log(content);
          content = content.replace(/width="(\d*)"/g, '');
          //console.log(content);

          // 统一设置 800px
          var regex = new RegExp('<img', 'gi');
          content = content.replace(regex, '<img style="width: 800px; margin-left:25px;"');
          self.richText =
            content;
    }).fail(function () {
    console.log('失败');
  });

      $.ajax({
        url:  Header.IP_URL + '/research_service/simpleList' ,    // ?type=1
        type: 'get',
        // data: {},
        dataType: 'json'
      }).then(function (res) {
        console.log(res);
        //把从json获取的数据赋值给数组
        self.kyfwList = res.data;
        for (var i = 0; i < self.kyfwList.length; i++) {
          self.kyfwList[i].url = '/service0?id=' + self.kyfwList[i].research_serviceId;
          // 页面刷新时，也要确保 左侧菜单是显示正确的
          if (category == 'zx') {
            if (self.kyfwList[i].type == 1) {
              self.kyfwList[i].display = "block";
            } else {
              self.kyfwList[i].display = "none";
            }
          } else if (category == 'pt') {
            if (self.kyfwList[i].type == 1) {
              self.kyfwList[i].display = "none";
            } else {
              self.kyfwList[i].display = "block";
            }
          }
        }
        if (category == 'zx'){
          document.getElementById("fxcs_o1").style.display = 'none';
          document.getElementById("fxcs_o2").style.display = 'none';
        }else if (category == 'pt') {
          document.getElementById("fxcs_o1").style.display = 'block';
          document.getElementById("fxcs_o2").style.display = 'block';
        }
      }).fail(function () {
        console.log('失败');
      });
    },
    components: {
      "v-header": Header,
      "v-nav": Nav,
      "v-copy": Copy,
      "v-breadcrumb": Breadcrumb,
      "v-footer": Footer,
      "v-contact": Contact,
    }
  };

</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
      @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
  }
  .b-richtext {
    //width: 98%;
    text-align:left;
    //padding-left: 250px;
    b,
    strong {
      font-weight: 700;
    }
    p {
      margin: 0 0 0px;
      line-height: 24px;
    }
    line-height: 24px;
  }

  .right {

    float:right ;
    position: relative;
    display: flex;

    .btn {
      width: 400px;
      text-align: right;
      height: 24px;
      line-height: 22px;
      font-size: 16px;
      //font-weight: bold;
      position: relative;
      cursor: pointer;
    }

    .hover_container {
      width: 400px;
      height: 300px;
      border: 1px solid #ccc;
   //   border-radius: 8px;
      border-radius: 8px;
      text-align: center;
      line-height: 100px;
      left: 200px;
      top: 0px;
      z-index: 1;
      opacity: 1;
      background-color: #f1f0f0;
      //transform: translateY(-50%);
    }
  }

  ///////////////
  .title {
    width: 230px;
    margin-bottom: 0px;
    position: relative;
    padding: 10px 15px 11px;
    background: #0c5cc8;
    font-size: 22px;
    font-weight: 500;
    color:#ffffff;
    text-transform:uppercase;
  }
  .contentLeft {
    width: 230px;
    height: 100%;
    float: left;
    //margin-right: 50px;
    top: 0;
    left: 0;
    background-color: #f2f7ff;
  }

  .contentRight {
    margin-left: 260px;
  }

  .leftNavigation {
    margin: 0rem 0;
  }
  .leftNavigation li {
    border-bottom: solid 1px #c6dbf5;
    border-right: solid 1px #c6dbf5;
    text-align: left;
  }
  .leftNavigation, .leftNavigation li ul {
    list-style: none;
    padding: 0;
  }
  .leftNavigation li a {
    font-size: 16px;
    display: block;
    padding: 10px 10px 10px 20px;
    color: #1f1f1f;
    /*border-bottom: solid 1px #1e76b8;*/
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    -webkit-transition: color 0.2s ease;
    transition: color 0.2s ease;
    font-weight:400;
    border-left: #c6dbf5 solid 5px;
    border-right: #c6dbf5 solid 5px;
  }
  .leftNavigation li a, .leftNavigation li a .leftNavIcon {
    line-height: 160%;
  }
  .leftNavigation li a .leftNavIcon {
    position: absolute;
    top: 0;
    left: -1px;
    /*width: 3rem;*/
    padding: 6px 0;
    text-align: center;
    font-weight:100;color: #f2f7ff;font-size: 20px;
  }
  .leftNavigation li.active a .leftNavIcon {color: #7396c3;}
  .leftNavigation li a .leftNavIcon1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 4rem;
    padding: 0.8rem 0;
    text-align: center;
  }
  .leftNavigation li a:hover {
    color: #142e8f; text-decoration:none; background:#d6e7fd;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li a:hover .leftNavIcon {color: #7396c3;}
  .leftNavigation li ul {
    /*display: none;*/
    margin: 0;border-top: solid 1px #c6dbf5;border-left: #c6dbf5 solid 5px;padding: 8px 0;
  }
  .leftNavigation li ul li { border-bottom: solid 0px #1e76b8;}
  .leftNavigation li ul li a {
    border: 0px; font-size:13px; color:#383838; background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;padding: 5px 15px 5px 48px;border-left: 0;
  }
  .leftNavigation li ul li a:hover {
    background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;color:#142e8f;text-decoration:none;border: 0;
  }
  /*#

   li ul li:last-child a {
    border-bottom: none;
  }*/
  .leftNavigation li ul li.active a {
    color: #8bebff; text-decoration:none;
  }
  .leftNavigation li.active > a {
    color: #142e8f; text-decoration:none;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li.active ul {
    display: block;border-top: solid 1px #1e76b8;
  }
  .leftNavigation > li.active {
    background-color: #d6e7fd;
  }
  .leftNavigation li ul li .level4 {border-top: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li a {
    border-bottom: solid 0px #D0E9F3; font-size:14px; color:#e2f5fa; padding-left:42px;background: transparent;border-left: #2473c0 solid 5px;
  }
  .leftNavigation li ul li .level4 li a:hover {color: #8bebff;}
  .leftNavigation li ul li .level4 li {border-bottom: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li:last-child {border-bottom: solid 0px #D0E9F3;}
</style>



// WEBPACK FOOTER //
// src/pages/Service0/index.vue